<template>
  <div class="Inspection">
    <div v-if="showInsp1">
      <Insp1
        :assessmen="this.assess"
        @assessChanged="assess = $event"
        @assessmentName="textInsp1 = $event"
        @assessmentHeader="headerInsp1 = $event"
        @assessmentActual="actualInsp1 = $event"
        @InspActual="showInsp2 = $event"
        @InspBefore="showInsp1 = $event"
        @prevPage1="showInsp1 = $event"
        @prevPage2="showInsp2 = $event"
      ></Insp1>
    </div>
    <div v-if="showInsp2">
      <Insp2
        :assessmen="this.assess"
        @assessChanged="assess = $event"
        @assessmentName="textInsp2 = $event"
        @assessmentHeader="headerInsp2 = $event"
        @assessmentActual="actualInsp2 = $event"
        @InspActual="showInsp3 = $event"
        @InspBefore="showInsp2 = $event"
        @prevPage1="showInsp1 = $event"
        @prevPage2="showInsp2 = $event"
      ></Insp2>
    </div>
    <div v-if="showInsp3">
      <Insp3
        :assessmen="this.assess"
        @assessChanged="assess = $event"
        @assessmentName="textInsp3 = $event"
        @assessmentHeader="headerInsp3 = $event"
        @assessmentActual="actualInsp3 = $event"
        @InspActual="showInsp4 = $event"
        @InspBefore="showInsp3 = $event"
      ></Insp3>
    </div>
    <div v-if="showInsp4">
      <Insp4
        :assessmen="this.assess"
        @assessChanged="assess = $event"
        @assessmentName="textInsp4 = $event"
        @assessmentHeader="headerInsp4 = $event"
        @assessmentActual="actualInsp4 = $event"
        @InspActual="showInsp5 = $event"
        @InspBefore="showInsp4 = $event"
      ></Insp4>
    </div>
    <div v-if="showInsp5">
      <Insp5
        :assessmen="this.assess"
        @assessChanged="assess = $event"
        @assessmentName="textInsp5 = $event"
        @assessmentHeader="headerInsp5 = $event"
        @assessmentActual="actualInsp5 = $event"
        @InspActual="showInsp6 = $event"
        @InspBefore="showInsp5 = $event"
      ></Insp5>
    </div>
    <div v-if="showInsp6">
      <Insp6
        :assessmen="this.assess"
        @assessChanged="assess = $event"
        @assessmentName="textInsp6 = $event"
        @assessmentHeader="headerInsp6 = $event"
        @assessmentActual="actualInsp6 = $event"
        @InspActual="showInsp7 = $event"
        @InspBefore="showInsp6 = $event"
      ></Insp6>
    </div>
    <div v-if="showInsp7">
      <Insp7
        :assessmen="this.assess"
        @assessChanged="assess = $event"
        @assessmentName="textInsp7 = $event"
        @assessmentHeader="headerInsp7 = $event"
        @assessmentActual="actualInsp7 = $event"
        @InspActual="showInsp8 = $event"
        @InspBefore="showInsp7 = $event"
      ></Insp7>
    </div>
    <div v-if="showInsp8">
      <Insp8
        :assessmen="this.assess"
        @assessChanged="assess = $event"
        @assessmentName="textInsp8 = $event"
        @assessmentHeader="headerInsp8 = $event"
        @assessmentActual="actualInsp8 = $event"
        @InspActual="showInspectionRes = $event"
        @InspBefore="showInsp8 = $event"
      ></Insp8>
    </div>
    <div v-if="showInspectionRes">
      <InspRes
        :assessmen="this.assess"
        :textI1="this.textInsp1"
        :textI2="this.textInsp2"
        :textI3="this.textInsp3"
        :textI4="this.textInsp4"
        :textI5="this.textInsp5"
        :textI6="this.textInsp6"
        :textI7="this.textInsp7"
        :textI8="this.textInsp8"
        :headerI1="this.headerInsp1"
        :headerI2="this.headerInsp2"
        :headerI3="this.headerInsp3"
        :headerI4="this.headerInsp4"
        :headerI5="this.headerInsp5"
        :headerI6="this.headerInsp6"
        :headerI7="this.headerInsp7"
        :headerI8="this.headerInsp8"
        :assessI1="this.actualInsp1"
        :assessI2="this.actualInsp2"
        :assessI3="this.actualInsp3"
        :assessI4="this.actualInsp4"
        :assessI5="this.actualInsp5"
        :assessI6="this.actualInsp6"
        :assessI7="this.actualInsp7"
        :assessI8="this.actualInsp8"
        @assessChanged="assess = $event"
        @InspActual="showInsp3 = $event"
        @InspBefore="showInspRes = $event"
      ></InspRes>
    </div>
  </div>
</template>

<script>
import Inspection1 from "./Inspection1";
import Inspection2 from "./Inspection2";
import Inspection3 from "./Inspection3";
import Inspection4 from "./Inspection4";
import Inspection5 from "./Inspection5";
import Inspection6 from "./Inspection6";
import Inspection7 from "./Inspection7";
import Inspection8 from "./Inspection8";
import InspectionRes from "./InspectionRes";

export default {
  name: "Inspection",
  data() {
    return {
      assess: 0,
      showInsp1: true,
      showInsp2: false,
      showInsp3: false,
      showInsp4: false,
      showInsp5: false,
      showInsp6: false,
      showInsp7: false,
      showInsp8: false,
      showInspectionRes: false,
      textInsp1: "",
      textInsp2: "",
      textInsp3: "",
      textInsp4: "",
      textInsp5: "",
      textInsp6: "",
      textInsp7: "",
      textInsp8: "",
      headerInsp1: "",
      headerInsp2: "",
      headerInsp3: "",
      headerInsp4: "",
      headerInsp5: "",
      headerInsp6: "",
      headerInsp7: "",
      headerInsp8: "",
      actualInsp1: 0,
      actualInsp2: 0,
      actualInsp3: 0,
      actualInsp4: 0,
      actualInsp5: 0,
      actualInsp6: 0,
      actualInsp7: 0,
      actualInsp8: 0
    };
  },
  components: {
    Insp1: Inspection1,
    Insp2: Inspection2,
    Insp3: Inspection3,
    Insp4: Inspection4,
    Insp5: Inspection5,
    Insp6: Inspection6,
    Insp7: Inspection7,
    Insp8: Inspection8,
    InspRes: InspectionRes
  }
};
</script>

<style>
</style>
